<template>
    <vuescroll>
        <div class="max-w-content">
            <div class="all-check-lists">
                <div class="article-header">
                    <p class="box-title">Все чек-листы</p>
                    <span class="js-hide-leaving-component" title="Закрыть" @click="$emit('close')">
                        <icon-base width="16" height="16" viewBox="0 0 16 16"><icon-arrow-close/></icon-base>
                    </span>
                </div>
                <branches-list :branchList="commonBranch" :draggable="false" :view="true" v-model="values"></branches-list>
            </div>
        </div>
        <div class="branch-btns-box" v-show="!$_.isEmpty(activeList)">
            <div class="sub-box">
                <a href class="btn" @click.prevent="addClick">Добавить</a>
            </div>
        </div>
    </vuescroll>
</template>

<script>
    import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
    import vuescroll from 'vuescroll';
    import {EDIT_BRANCH, COPY_BRANCH} from '../../constants/common'
    import BranchesList from "./BranchesList";
    import IconBase from "../common/IconBase";
    import IconArrowClose from "../common/icons/IconArrowClose";

    export default {
        name: 'add-checklists',
        components: {
            IconArrowClose,
            IconBase,
            BranchesList,
            vuescroll,
        },
        computed: {
            ...mapState({
                controlType: state => state.checkLists.controlType,
                commonBranch: state => state.checkLists.common,
                activeBranch: state => state.checkLists.activeBranch,
                visibleControlsId: state => state.checkLists.visibleControlsId,
                activeList: state => state.checkLists.activeList
            }),
            ...mapGetters('checkLists', [
                'getPersonalBranch'
            ]),
            getBranch() {
                return this.$store.state.checkLists.personal.find((x => x.id === this.activeBranch))
            },
            branch: {
                get() {
                    return this.activeBranch
                },
                set(value) {
                    this.$store.commit('checkLists/setPersonalLists',  value)
                }
            },
        },
        data () {
            return {
                values: [
                ],
                loading: false,
                personalActionsList: [
                    /*{
                        title: 'Редактировать',
                        action: 'checkLists/editBranch'
                    },
                    {
                        title: 'Копировать',
                        action: 'checkLists/copyBranch'
                    },
                    {
                        title: 'В избранное',
                        action: 'copy'
                    },*/
                    {
                        title: 'Удалить',
                        action: 'checkLists/deleteList',
                        needConfirm: true,
                    },
                ],
                EDIT_BRANCH: EDIT_BRANCH,
                COPY_BRANCH: COPY_BRANCH
            }
        },
        methods: {
            ...mapMutations('checkLists', [
                'setControlsVisibility',
                'closeEdit',
                'copyListsToActiveBranch'
            ]),
            ...mapActions('checkLists', [
                'saveBranch',
                'pushBranch',
                'setActiveList',
            ]),
            clickControls(e) {
                if (this.visibleControlsId !== e) {
                    this.setControlsVisibility(e);
                } else {
                    this.setControlsVisibility(null);
                }
            },
            saveClick() {
                this.loading = true;
                if (this.controlType === EDIT_BRANCH) {
                    this.saveBranch().then(() => {
                        this.loading = false;
                        this.closeEdit()
                    })
                } else {
                    this.pushBranch().then(() => {
                        this.loading = false;
                        this.closeEdit()
                    })
                }
            },
            addClick() {
                let lists = [];
                this.commonBranch.forEach((branch, i) => {
                   branch.lists.forEach((list, j) => {
                       if (this.values[i] && this.values[i][j] ) {
                           let newList = Object.assign({}, list);
                           newList.checked = true;
                           lists.push(newList)
                       }
                   })
                });
                this.copyListsToActiveBranch(lists);
                this.values = [];
                this.setActiveList(false);
            }
        },
    }
</script>

<style scoped>

</style>
